import { Skill } from '../../types';

export const SKILLS = [
  {
    group: 'Languages',
    items: [
      Skill.TypeScript,
      Skill.JavaScript,
      Skill.HTML,
      Skill.CSS,
      Skill.SCSS,
      Skill.GraphQL,
      Skill.Python,
      Skill.Swift,
      Skill.Java,
      Skill.CSharp,
      Skill.Rust,
    ],
  },
  {
    group: 'Frameworks & Libraries',
    items: [
      Skill.React,
      Skill.Redux,
      Skill.RTKQuery,
      Skill.ApolloClient,
      Skill.Node,
      Skill.Express,
      Skill.Tailwind,
      Skill.DaisyUI,
      Skill.StyledComponents,
      Skill.RadixUI,
      Skill.ProseMirror,
      Skill.Yjs,
      Skill.FramerMotion,
      Skill.Recharts,
    ],
  },
  {
    group: 'Tools & Practices',
    items: [
      Skill.WebRTC,
      Skill.WebSockets,
      Skill.Jest,
      Skill.Auth0,
      Skill.RESTAPIs,
      Skill.PerformanceOptimization,
      Skill.SystemDesign,
      Skill.E2EEncryption,
    ],
  },
];
